import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import './Login.module.css'
import { Services } from '@/services/services';
import { Translates } from '@/services/repository/i18n';
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
// import { LoginForm } from '@/services/repository/users';

export interface FormBase {
  _general: string
}

export interface FormData extends FormBase {
  username: string
  password: string
}

export interface FormError {
  message: string
}

export type FormErrors<T> = {
  [K in keyof T]: FormError;
}

export const LoginForm = ({ services, onSubmit, serverErrors, form }: { services: Services, onSubmit: (data: FormData, resetForm: () => void) => Promise<void>, serverErrors: FormErrors<FormData> | undefined, form: UseFormReturn<FormData> }) => {
  const [translates, setTranslates] = useState<Translates>()
  const navigate = useNavigate()
  const {
    setFocus,
    register,
    setError,
    handleSubmit,
    reset,
    formState: { errors }
  } = form

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])

  useEffect(() => {
    if (serverErrors === undefined) {
      return
    }
    for (let i in serverErrors) {
      const key = i as keyof FormData
      setError(key, {
        type: 'server',
        message: translates?.for(serverErrors[key]!.message)
      })
      setFocus(key)
    }
  }, [translates, serverErrors])

  const handleFormSubmit: SubmitHandler<FormData> = (data) => {
    onSubmit(data, reset)
  };

  if (translates === undefined) {
    return (<div className='spinner'></div>)
  }

  return (<form onSubmit={handleSubmit(handleFormSubmit)}>
    {/* Username Field */}
    <div className='form-field form-field-with-icon'>
      {/* <label htmlFor='username'>{translates.for('forms.login.fields.username.title')}:</label> */}
      <img className='icon' src='/public/img/icons/field-user.svg' />
      <input
        type='text'
        id='username'
        placeholder={translates.for('forms.login.fields.username.placeholder')}
        {...register('username', {
          required: translates.for('forms.login.errors.fields.username.required')
        })}
      />
      {errors.username && <p className='errorMessage'>{errors.username.message}</p>}
    </div>

    {/* Password Field */}
    <div className='form-field form-field-with-icon'>
      {/* <label htmlFor='password'>{translates.for('forms.login.fields.password.title')}:</label> */}
      <img className='icon' src='/public/img/icons/field-password.svg' />
      <input
        type='password'
        id='password'
        placeholder={translates.for('forms.login.fields.password.placeholder')}
        {...register('password', {
          required: translates.for('forms.login.errors.fields.password.required'),
        })}
      />
      {errors.password && <p className='errorMessage'>{errors.password.message}</p>}
    </div>

    <div className='resetpassword-wrap' onClick={() => navigate('/resetpassword')}>
      {translates?.for('page.login.resetpassword')}
    </div>

    <button className='submit-button' type='submit'>{translates.for('forms.login.submit')}</button>
    {errors._general && <p className='errorMessage'>{errors._general.message}</p>}
  </form>)
}
